export interface IGetEventsDto {
    from: string;
    to: string;
    eventId?: string;
    eventType?: string;
    deviceExternalId?: string;
    includeExternal?: boolean;
}
